import { render, staticRenderFns } from "./FeedPurchase.vue?vue&type=template&id=e1f6bea4&scoped=true&"
import script from "./FeedPurchase.vue?vue&type=script&lang=js&"
export * from "./FeedPurchase.vue?vue&type=script&lang=js&"
import style0 from "./FeedPurchase.vue?vue&type=style&index=0&id=e1f6bea4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f6bea4",
  null
  
)

export default component.exports